import React, { useEffect } from 'react';
import { Box, Container } from '@mui/material';
import AccountingSheetView from '../components/contents/AccountingSheetView';

const AccountingsPage = () => {
    // Установка заголовка для страницы предписаний
    useEffect(() => {
        document.title = "Предписания";
    }, []);

    return (
        <Container maxWidth={true} sx={{ p: {xs: 0, md: 0}, height: '100vh' }}>
            <Box sx={{ 
                height: '100%', 
                display: 'flex', 
                flexDirection: 'column',
                overflow: 'hidden'
            }}>
                <AccountingSheetView
                    isModal={false}
                    onClose={null}
                    map={null}
                    fromStartPage={true}
                />
            </Box>
        </Container>
    );
};

export default AccountingsPage; 